export type RichTextFeature =
  | 'bold'
  | 'italic'
  | 'underline'
  | 'strike'
  | 'code'
  | 'blockquote'
  | 'bulletList'
  | 'orderedList'
  | 'heading'
  | 'textAlign'
  | 'link'
  | 'image'
  | 'youtube'
  | 'textStyle';

export const ALL_RICH_TEXT_FEATURES: RichTextFeature[] = [
  'bold',
  'italic',
  'underline',
  'strike',
  'code',
  'blockquote',
  'bulletList',
  'orderedList',
  'heading',
  'textAlign',
  'link',
  'image',
  'youtube',
  'textStyle',
];
